module.exports = __webpack_public_path__ + "media/newstyle/images/stars_sprint_red-48d4497f657968b44e181888be8a7f72.svg";